<template>
  <div class="banner overflow-hidden" :style="customStyle">
    <div class="container d-flex flex-column flex-md-row">
      <div class="banner__content col-md-7">
        <h1 class="mb-16">
          {{ title }}
        </h1>
        <p v-if="subtitle" class="banner__subtitle text-large mb-0 pr-8">
          {{ subtitle }}
        </p>

        <slot name="button"> </slot>
      </div>

      <slot name="illustration">
        <GroupReadingIllustration
          class="illustration align-self-end align-self-md-center"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import GroupReadingIllustration from '~/assets/illustrations/group-reading.svg'

export default {
  components: {
    GroupReadingIllustration,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    customStyle: {
      type: Object,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  background-color: $mint-light;
}

.banner__content {
  z-index: 2;
  max-width: 800px;
  padding-top: 40px;
}

.banner__subtitle {
  max-width: 382px;
}

.illustration {
  width: 224px;
  height: auto;
  z-index: 1;
  margin-bottom: -46px;
}

@include media-breakpoint-up(md) {
  .container {
    justify-content: space-between;
  }

  .banner__content {
    padding-top: 60px;
    padding-bottom: 70px;
  }

  .illustration {
    height: auto;
    width: 280px;
    margin-bottom: -64px;
  }
}

@include media-breakpoint-up(lg) {
  .banner {
    padding: 0;
  }

  .banner__content {
    padding-top: 100px;
    padding-bottom: 110px;
  }

  .banner__subtitle {
    max-width: 530px;
  }

  .illustration {
    width: 424px;
    margin-top: -34px;
  }
}

@include media-breakpoint-up(xl) {
  .banner__subtitle {
    max-width: 645px;
  }
}
</style>
